import React, {useContext} from 'react';
import Button from '@mui/material/Button';
import {FormProvider} from "react-hook-form";
import TextFieldControl from "../../../../Controls/Inputs/TextFieldControl";
import strings from "../../../../../localization";
import TablePageContext from "../../../../../Context/TablePageContext";
import PageState from "../../../../../Constants/Base/PageState";
import AutoCompleteControl from '../../../../Controls/Inputs/AutoCompleteControl';

const InventoryForm = ({
                         onSubmit,
                         onCancel,
                         data,
                         form,
                         errors,
                         inventoryTypes,
                         inventoryLocations,
                         control,
                         values,
                         setValue,
                         formRules,
                         onLocationChangeFilter,
                         onTypeChangeFilter,
                     }) => {

    const {pageState} = useContext(TablePageContext);
    const isPageStateViewDetails = () => pageState === PageState.ViewDetails;


    return (
        <FormProvider {...form}>
            <form id='inventory-form' className='form' action="#">

                <TextFieldControl
                    name='value'
                    rules={formRules['value']}
                    control={data}
                    type="number"
                    error={Boolean(errors.value)}
                    helperText={errors.value && strings.forms.common.thisFieldIsRequired}
                    label={strings.forms.assetManagement.inventoryForm.value}
                    disabled={isPageStateViewDetails()}
                />

                <TextFieldControl
                    name='quantity'
                    rules={formRules['quantity']}
                    control={data}
                    type="number"
                    error={Boolean(errors.quantity)}
                    helperText={errors.quantity && strings.forms.common.thisFieldIsRequired}
                    label={strings.forms.assetManagement.inventoryForm.quantity}
                    disabled={isPageStateViewDetails()}
                />

                <TextFieldControl
                    name='lowStockTrashold'
                    rules={formRules['lowStockTrashold']}
                    control={data}
                    error={Boolean(errors.lowStockTrashold)}
                    helperText={errors.lowStockTrashold && strings.forms.common.thisFieldIsRequired}
                    label={strings.forms.assetManagement.inventoryForm.lowStockTrashold}
                    disabled={isPageStateViewDetails()}
                />

                <AutoCompleteControl
                    value={values['location']}
                    setValue={setValue}
                    name='location'
                    control={control}
                    label={strings.forms.assetManagement.inventoryForm.location}
                    options={inventoryLocations}
                    nameKey={'name'}
                    valueKey={'id'}
                    disabled={isPageStateViewDetails()}
                    onChange={onLocationChangeFilter}
                    onOpen={() =>onLocationChangeFilter('')}
                />

                <AutoCompleteControl
                    value={values['type']}
                    setValue={setValue}
                    name='type'
                    control={control}
                    label={strings.forms.assetManagement.inventoryForm.type}
                    options={inventoryTypes}
                    nameKey={'name'}
                    valueKey={'id'}
                    disabled={isPageStateViewDetails()}
                    onChange={onTypeChangeFilter}
                    onOpen={() =>onTypeChangeFilter('')}
                />

                {
                    !isPageStateViewDetails() && <div className='submit-container'>
                        <Button variant="contained" color="primary" onClick={onSubmit}>
                            {strings.forms.common.save}
                        </Button>
                        <Button variant="contained" color="secondary" onClick={onCancel}>
                            {strings.forms.common.cancel}
                        </Button>
                    </div>
                }

            </form>
        </FormProvider>
    );
}

export default InventoryForm;